import Swiper from "swiper";
import { Navigation, A11y } from "swiper/modules";
import "swiper/css";

export default class TestimonialsSlider {
  static init() {
    document.querySelectorAll(".testimonials-slider__slider").forEach((el) => {
      // Find the navigation buttons specific to this slider instance
      const section = el.closest(".testimonials-slider");
      const prevBtn = section.querySelector(".testimonials-slider__navigation-prev");
      const nextBtn = section.querySelector(".testimonials-slider__navigation-next");

      new Swiper(el, {
        modules: [Navigation, A11y],
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        
        a11y: {
          enabled: true,
        },
        
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
    });
  }
}